import { NotablePlainDateAsMidnightUtcSchema } from 'notable-common';
import { z } from 'zod';
import { GuarantorKind } from './kind.js';
import { EmploymentStatus, Race, Relationship, SexUpper } from '../demographics/index.js';
/**
 * A guarantor as primary serves it — the party responsible for a patient's bill.
 *
 * Everything but the identity columns is nullable: a guarantor is assembled from whatever the EHR
 * supplied. The `*Raw` fields carry the EHR's own string for the neighbouring coded field, kept for
 * the cases where it did not map onto one of our values.
 */
export const GuarantorSchema = z.object({
    id: z.uuid(),
    created: z.iso.datetime(),
    updated: z.iso.datetime(),
    ehrInformationId: z.uuid(),
    ehrId: z.string().nullable(),
    firstName: z.string().nullable(),
    lastName: z.string().nullable(),
    sex: z.enum(SexUpper).nullable(),
    dateOfBirth: NotablePlainDateAsMidnightUtcSchema.nullable(),
    kind: z.enum(GuarantorKind).nullable(),
    relationshipToPatient: z.enum(Relationship).nullable(),
    relationshipToPatientRaw: z.string().nullable(),
    phoneNumberHome: z.string().nullable(),
    phoneNumberMobile: z.string().nullable(),
    phoneNumberWork: z.string().nullable(),
    emailAddress: z.string().nullable(),
    employer: z.string().nullable(),
    employmentStatus: z.enum(EmploymentStatus).nullable(),
    employmentStatusRaw: z.string().nullable(),
    ssn4: z.string().nullable(),
    race: z.array(z.enum(Race)).nullable(),
    raceRaw: z.array(z.string()).nullable(),
    addressId: z.uuid().nullable(),
    verifiedTimestamp: z.iso.datetime().nullable(),
    deletedTimestamp: z.iso.datetime().nullable(),
});
/** Query params for `GET /flow/data-access/guarantors`. */
export const GuarantorFindAllQuerySchema = z
    .object({
    ehrInformationId: z.uuid(),
})
    .strict();
//# sourceMappingURL=guarantor.js.map